import { motion } from 'framer-motion';
import { IconBrandX, IconBrandLinkedin } from '@tabler/icons-react';

export default function Footer() {
  return (
    <footer className="py-12 bg-black border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-400">
              Luxury Hire
            </h3>
            <p className="text-gray-400 mt-2">
              Disrupting the luxury automotive management
            </p>
          </div>

          {/* Social Links */}
          <div className="flex gap-6">
            {[
              { icon: IconBrandX, href: '#' },
              { icon: IconBrandLinkedin, href: '#' }
            ].map((social, index) => (
              <motion.a
                key={index}
                href={social.href}
                whileHover={{ scale: 1.1 }}
                className="text-gray-400 hover:text-amber-400 transition-colors"
              >
                <social.icon className="w-6 h-6" />
              </motion.a>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            LuxuryHire. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            © 2025 DataScienceLondon
          </p>
        </div>
      </div>
    </footer>
  );
} 